<template>
  <div
    class="question-image__wrapper"
    id="canvas-question-image-wrapper"
    @click.prevent="expandCollapseTrigger('image')"
  >
    <Loading v-if="isLoading" />
    <div
      class="question-image __image-wrapper"
      :class="{
        'pointer-events-none': isLockPointerEvent,
        'image-pointer-zoom-in': questionImageLayoutMode === 'default',
        'image-pointer-zoom-out': questionImageLayoutMode === 'image',
        '__image-wrapper-poll-mode': questionImageLayoutMode !== 'image'
      }"
      v-if="questionImage && !isLoading"
      id="img-wrapper"
    >
      <div
        v-if="!isPresenting"
        class="question-image __icons"
        :class="{
          'absolute top-12 z-50' : questionImageLayoutMode === 'image'
        }"
      >
        <div
          class="question-image __edit-wrapper"
          @click.stop="openEditQuestionImageModal"
          v-tooltip="$i18nPresenter.t('Edit image')"
        >
          <font-awesome-icon
            icon="pencil-alt"
            class="question-image __icon"
          />
        </div>
        <div
          class="question-image __delete-wrapper"
          @click.stop="openDeleteQuestionImageModal"
          v-tooltip="$i18nPresenter.t('Delete')"
        >
          <font-awesome-icon
            icon="trash-alt"
            class="question-image __icon"
          />
        </div>
      </div>
      <div
        v-if="questionImageLayoutMode === 'image'"
        class="absolute top-12 right-4 z-50"
      >
        <div
          class="collapse-icon"
          @click.stop="expandCollapseTrigger('default')"
          v-if="questionImageLayoutMode === 'image'"
        >
          <i
            class="fas fa-compress-alt __icon"
          ></i>
        </div>
      </div>
      <div class="relative inline overflow-hidden">
        <div
          v-if="questionImageLayoutMode !== 'image'"
          class="absolute top-2 right-2"
          id="expand-icon-wrapper"
        >
          <div
            class="expand-icon"
            @click.stop="expandCollapseTrigger('image')"
            v-if="questionImageLayoutMode === 'default'"
          >
            <i
              class="fas fa-expand-alt __icon"
              style="font-size: 24px; padding-top: 6px"
            ></i>
          </div>
        </div>
        <img
          :src="questionImage"
          alt
          class="question-image __image"
          ref="slide-imgg"
          @load="imageLoaded"
          id="canvas-question-image"
          @click.stop="expandCollapseTrigger('image')"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'

export default {
  components: {
    Loading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    questionImageLayoutMode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    isLockPointerEvent() {
      if (this.questionImageLayoutMode === 'image' || this.questionImageLayoutMode === 'default') return false
      return this.isPresenting || this.isBackstage
    },
    questionImage() {
      return (this.slideActive.image && this.slideActive.image.xLarge)
    },
  },
  mounted() {
    this.absoluteRightExpandProcessing()
  },
  updated() {
    this.absoluteRightExpandProcessing()
  },
  methods: {
    absoluteRightExpandProcessing() {
      this.$nextTick(() => {
        const imgWrapper = document.getElementById('img-wrapper')
        const slideImgg = document.getElementById('canvas-question-image')
        const expandWrapper = document.getElementById('expand-icon-wrapper')
        if (!expandWrapper) return
        if (!imgWrapper || !slideImgg) expandWrapper.style.right = '0.5rem'
        if (slideImgg.clientWidth === 0) return
        const val = ((imgWrapper.clientWidth - slideImgg.clientWidth) / 2 + 8) || 8
        expandWrapper.style.right = `${val}px`
      })
    },
    openEditQuestionImageModal() {
      EventBus.$emit('open-edit-question-image-modal')
    },
    openDeleteQuestionImageModal() {
      EventBus.$emit('open-delete-question-image-modal')
    },
    expandCollapseTrigger(val) {
      this.$emit('expandCollapseTrigger', val)
    },
    imageLoaded() {
      this.absoluteRightExpandProcessing()
      this.$emit('imageLoaded')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-image__wrapper {
  width: 100%;
  height: 100%;
  padding: 30px;
  margin: 0px auto;
  &::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
  &::v-deep .context-menu-wrapper {
    min-width: 3rem;
  }
  .context-menu-item__wrapper {
    padding-left: 0;
    margin-bottom: 0;
  }

  .question-image {
    &.__icons {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #ccc;
      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
      width: max-content;
      opacity: 0;
      .__edit-wrapper {
        @apply p-2 pr-2 cursor-pointer;
        &:hover .__icon {
          @apply text-primary-100;
        }
      }
      .__delete-wrapper {
        @apply p-2 pl-2 cursor-pointer;
        &:hover .__icon {
          @apply text-red-100;
        }
      }
    }
    &.__icon {
      font-size: 1.25em;
      @apply text-base-100;
    }
    &.__image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: table;
      margin: 0 auto;
    }
    &.__image-wrapper {
      @apply h-full w-full my-0 mx-auto;
      &:hover {
        .__icons {
          opacity: 1;
          transition: opacity 0.2s ease-out;
        }
        .expand-icon {
          opacity: 1;
        }
        .collapse-icon {
          opacity: 1;
        }
      }
    }
    &.__image-wrapper-poll-mode {
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
    }
  }
  .expand-icon {
    @apply w-10 h-10 absolute rounded top-1 right-1 text-center cursor-pointer;
    background-color: #ffffff;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
    opacity: 0;
    i {
      @apply text-base-100;
    }
    &:hover {
      i {
        @apply text-primary-100;
      }
    }
  }
  .collapse-icon {
    @apply w-10 h-10 absolute rounded right-8 text-center cursor-pointer;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #ccc;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
    opacity: 0;
    i {
      @apply text-base-100;
      font-size: 24px;
      padding-top: 8px;
    }
    &:hover {
      i {
        @apply text-primary-100;
      }
    }
  }
  .image-pointer-zoom-in {
    cursor: zoom-in !important;
  }
  .image-pointer-zoom-out {
    cursor: zoom-out !important;
  }
}
</style>
